import { Server } from './core/server/server';
import { Database } from './database/database/database';

export const server: Server = new Server();
